import { useQueryClient } from '@tanstack/react-query'
import { useAuthMutation } from './auth'
import { ApiAgentRequest, request } from '../utils/request'
import { PassportResource } from '@backend/agents-ui-api/resources/student-document/passport/types'

export type UpdatePassportParams = {
  id: string
  passportNumber?: string
  expiryDate?: string
  nationality?: string
}

export type RawPassportResponse = {
  data: PassportResource
}


export function useUpdatePassport() {
  const queryClient = useQueryClient()

  const { isPending, mutate } = useAuthMutation(
    async (params: UpdatePassportParams) => {
      return await request<RawPassportResponse>(
        new ApiAgentRequest(`/students/documents/passports/${params.id}`, {
          method: 'PATCH',
          body: {
            data: {
              type: 'passport',
              attributes: {
                passportNumber: params?.passportNumber ?? null,
                expiryDate: params?.expiryDate ?? null,
                nationality: params?.nationality ?? null,
              },
            },
          },
        }),
        {
          isExpectedResponse: (res): res is RawPassportResponse => res as boolean,
        },
      )
    },
    {
      onSuccess: data => {
        queryClient.setQueryData(['passport'], data)
      },
    },
  )

  return {
    isUpdatingPassport: isPending,
    updatePassport: mutate,
  }
}
